export const actions = {
	DRAWING: "DRAWING",
};
